import '@styles/webdesktop/stylesheets/baseNumeric.scss';
import React from 'react';
import { Typography } from '../../../Typography/Typography';
import { TypographyLevel } from '../../../Typography/TypographyLevel';
export const NumericPrefix = ({ prefix }) => {
    return (React.createElement(Typography, { className: "numeric-prefix", level: TypographyLevel.BodySm, noWrap: true }, prefix));
};
